import React from 'react';
import Paper from '@material-ui/core/Paper';

const BrandEquity = (data: any) => {
  if (!data.payload || data.payload.length === 0) return null;
  const { t } = data;

  const labelData = data.payload[0];
  return (
    <Paper style={{ padding: '1rem' }}>
      <strong>{labelData.payload.name}</strong>
      <p>{`${t('charts.brandEquity.equity', ' Equity')}: ${
        labelData.payload.equity
      }`}</p>
      <p>{`${t(
        'charts.brandEquity.influencer',
        'Influencer'
      )}: ${labelData.payload.influencer.toFixed(2)} `}</p>
    </Paper>
  );
};

export default BrandEquity;
